import Gleap from 'gleap';

// eslint-disable-next-line import/prefer-default-export
export function openHelp(articleId: string, showBackButton = false): void {
  if (typeof Gleap !== 'undefined' && Gleap.openHelpCenterArticle) {
    Gleap.openHelpCenterArticle(articleId, showBackButton);
  } else {
    console.warn('[Gleap] Gleap is not available.');
  }
}
